<template>
    <div>
        <template v-if="!isComplete">
            Загружается...
            </template>
            <template v-else-if="items.length > 0">
        <table class="table-custom ">
                            
                            <thead>
                            <tr>
                                <th width="50px"></th>
                                <th>Дата создания</th>
                                <th width="15%">Дата и время прохождения</th>
                                <th>Организация</th>
                                <th>Автор</th>
                                <th>Дата и время утверждения</th>

                            </tr>
                            </thead>
                           
                            <tbody>
                                <tr v-for="(item) in items" v-bind:key="item.id">
                                    <td><menu-component class="actions" :actions="actions(item)" /></td>
                                    <td>{{ $momentFormat(item.created, "DD.MM.YYYY HH:mm") }}</td>
                                    <td>{{ $momentFormat(item.dateEnter, "DD.MM.YYYY HH:mm") }}</td>
                                    <td>{{ item.organizationName }}</td>
                                    <td>{{ item.approvedUser }}</td>
                                    <td>{{ $momentFormat(item.dateApproved, "DD.MM.YYYY HH:mm") }}</td>

                                </tr>
                            </tbody>
                        </table>
</template>
<template v-else>
        <EmptyListMessage/>
      </template>


    <section class="modals">
        <modal-component v-if="modals.show" title="Карточка диагностики" @close="modals.show = false">
          <diagnostic-card :card-id="modals.id" :is-readonly="modals.isReadonly" @close="modals.show = false" @save="modals.show = false;loadPage();"  />
        </modal-component>
      </section>
      <div class="card-footer mt-5">
          <div class="d-flex align-items-center float-right">
            <button-component kind="secondary" type="button" class="btn btn-default" v-on:click="close">Закрыть</button-component>
          </div>
      </div>     
    </div>
</template>
<script>
import API from '../api/diagnostic'
import Constants from '@/common/constants'
import ModalComponent from "@/common/ui/ModalComponent";
import DiagnosticCard from '../views/DiagnosticCard.vue';
import MenuComponent from "../../../common/ui/components/page/MenuComponent";
import ButtonComponent from "../../../common/ui/ButtonComponent";


export default {
  name: "JournalTabDiagnostic",
  components: {
    MenuComponent,
    ButtonComponent,
    DiagnosticCard,
    ModalComponent
  },
  props: {
    journalId: Number,
    isReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    items: [],
    isComplete: false,
    modals: {
        show: false,
        id: null,
        isReadonly: false
    }
  }),
  created() {
    this.loadPage();
  },
  watch: {
            journalId: function (/*newValue, oldValue*/) {
                this.loadPage();
            }
        },
  methods: {
    actions(item){
      let result = [];
      result.push({
        title: 'Просмотр',
        icon: 'eye',
        click: () =>  this.viewCard(item.id)
      });
      if (!this.isReadonly) {
        if (item.canEdit) {
          result.push({
            title: 'Редактировать',
            icon: 'pen',
            click: () => this.editCard(item.id)
          });
        }
        result.push({
          title: 'Обновить',
          icon: 'refresh',
          click: () => this.refreshCard(item.id)
        });
        if (item.canApproved) {
          result.push({
            title: 'Утвердить',
            icon: 'thumbs-up',
            click: () => this.approveCard(item.id)
          });
        }
        if (item.canDelete) {
          result.push({
            title: 'Удалить',
            icon: 'delete',
            click: () => this.deleteCard(item.id)
          });
        }
      }
      return result;
    },
    loadPage() {
        if(this.journalId > 0) {
      var self = this;
      self.isComplete = false;
      API.search({journalId : this.journalId}).then(function (response) {
        self.items = response.data;
         self.isComplete = true;
      });      
        }      
    },
    viewCard(id) {
      this.modals.id = id;
      this.modals.show = true;
      this.modals.isReadonly = true;
    },
    editCard(id) {
      this.modals.id = id;
      this.modals.show = true;
      this.modals.isReadonly = false;
    },
    approveCard(id) {
      var self = this;
      var alertOptions = {
          title: 'Подтверждение',
          text: 'Вы действительно хотите утвердить эту запись?',
          confirmButtonText: 'Утвердить',
          cancelButtonText: 'Отмена',
          showCancelButton: true,
          icon: 'warning',
        };
      Constants.alert.fire(alertOptions).then((res) => {
        if (res.isConfirmed) {
          API.approve(id).then(function (response) {
            Constants.alert.fire('Утверждение', response.data.message, response.data.success ? 'success' : 'error');
            if(response.data.success) {
                self.loadPage();
                self.$emit('approve');
            }
            
          })
        }
      });
    },
    deleteCard(id) {
      var self = this;
      Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
        if (res.isConfirmed) {
          API.delete(id).then(function (response) {
            Constants.alert.fire('Удаление', response.data.message, response.data.success ? 'success' : 'error');
            self.loadPage();
          })
        }
      });
    },
    close() {
      this.$router.push({name: 'Journal', query: { page1: this.$route.query.page1 }});
    },      
  },
};
</script>
<style lang="scss" scoped>
.card-footer{
    padding: 0;
    background-color: transparent;
    border: none;
}
</style>